<app-modal-mensagem
  *ngIf="!resultado"
  tipo="confirmacao"
  titulo="Concluir tarefa"
  mensagem="Tem certeza que deseja marcar esta tarefa como concluída?"
  textoConfirmar="Confirmar"
  [exibirCancelar]="true"
  (confirmar)="confirmarConclusao()"
  (cancelar)="fecharModal()"
></app-modal-mensagem>

<app-modal-mensagem
  *ngIf="resultado"
  [tipo]="resultado.tipo"
  [titulo]="resultado.titulo"
  [mensagem]="resultado.mensagem"
  (confirmar)="onFecharResultado()"
></app-modal-mensagem>
